import { FC } from 'react';
import { FlagIconProps } from './flagIcon.type';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'flag';

const FlagIcon: FC<FlagIconProps> = (props) => {
  return (
    <div
      className={`w-4 h-4 rounded-full ${props.className}`}
      {...getIdAttributes(idPrefix, 'icon')}
      style={{
        backgroundImage: `url("data:image/svg+xml;utf8,${encodeURIComponent(
          props.svg,
        )}")`,
      }}
    />
  );
};

export default FlagIcon;
